import { useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';

const useDevice = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const userAgent = useMemo(() => navigator.userAgent, []);

  const deviceType = useMemo(() => {
    if (/iPhone|iPad|iPod/i.test(userAgent)) return 'iOS';
    if (/Android/i.test(userAgent)) return 'Android';
    return 'Desktop';
  }, [userAgent]);

  const isSafari = useMemo(() => {
    return (
      /Safari/i.test(userAgent) && !/Chrome|CriOS|Android/i.test(userAgent)
    );
  }, [userAgent]);
  return { isMobile, deviceType, isSafari };
};

export default useDevice;
